export const N = 8;

export const BLACK = 'black' as const;
export const WHITE = 'white' as const;

export type Color = typeof BLACK | typeof WHITE;
export type Cell = Color | null;
export type Board = Cell[][];

export type Dir = readonly [number, number];

export const DIR_UP: Dir = [-1, 0];
export const DIR_DOWN: Dir = [1, 0];
export const DIR_LEFT: Dir = [0, -1];
export const DIR_RIGHT: Dir = [0, 1];
export const DIRS: readonly Dir[] = [DIR_UP, DIR_DOWN, DIR_LEFT, DIR_RIGHT];

export const PHASE = {
  SETUP_B: 'setup_b',
  SETUP_W: 'setup_w',
  SELECT: 'select',
  CAPTURE: 'capture',
  MULTI: 'multi',
  OVER: 'over',
} as const;

export type Phase = (typeof PHASE)[keyof typeof PHASE];

export interface Position {
  r: number;
  c: number;
}

export interface Move {
  /** Source row of the moving piece. */
  fr: number;
  /** Source column of the moving piece. */
  fc: number;
  /** Destination row (empty square the piece lands on). */
  tr: number;
  /** Destination column. */
  tc: number;
  /** Row of the captured opponent piece (between source and destination). */
  cr: number;
  /** Column of the captured opponent piece. */
  cc: number;
  /** Direction of this jump. */
  dir: Dir;
}

export interface GameState {
  board: Board;
  phase: Phase;
  /** Whose turn it is. In OVER phase this is the loser; use `winner` for the winner. */
  turn: Color;
  /** Currently selected piece (during CAPTURE / MULTI). */
  sel: Position | null;
  /** Where Black removed during opening (used to compute White's adjacent options). */
  removed: Position | null;
  /** Locked direction during MULTI; null otherwise. */
  dir: Dir | null;
  /** Valid moves for the currently-selected piece. */
  moves: Move[];
  caps: { black: number; white: number };
  winner: Color | null;
  /** Monotonically increasing turn counter (incremented on each completed turn). */
  turnCount: number;
}
